// extracted by mini-css-extract-plugin
export var columnList = "_g9-0";